/* istanbul ignore file */
export { default } from './MultiAccordions';
